<script>
import Vue from "vue"
import VueStripeCheckout from "vue-stripe-checkout"
import {dateToYMD} from "@/common/utils/index.js"
import axios from "axios"

// non real key.
Vue.use(VueStripeCheckout, "pk_test_O4233q7Kji8tPVNd2qna4MIO")

export default {
  mounted() {
    this.loadSettings()
  },
  // components: {
  //   'vue-stripe-checkout': VueStripeCheckout
  // },
  data() {
    return {
      loading: true,
      fluencyRecordingPossible: false,
      subscriptionInformationLoading: true,
      successMessage: "",
      email: "", // for stripe
      publishableKey: "",
      hrefs: {
        permission_slip: "/teacher/file/download/student-fluency-permission-slip.docx",
        stripe_pay: "/subscribe",
      },
      isActualTeacher: false,
      studentForm: {
        errorMessage: "",
        successMessage: "",
        saving: false,
        dirty: false,
      },
      loginForm: {
        errorMessage: "",
        successMessage: "",
        saving: false,
        dirty: false,
      },
      infoForm: {
        errorMessage: "",
        successMessage: "",
        saving: false,
        dirty: false,
      },
      promoForm: {
        errorMessage: "",
        successMessage: "",
        saving: false,
        dirty: false,
      },
      subscriptionForm: {
        errorMessage: "",
        successMessage: "",
        saving: false,
      },
      cancelForm: {
        errorMessage: "",
        successMessage: "",
        saving: false,
        dirty: false,
      },
      resumeForm: {
        errorMessage: "",
        successMessage: "",
        saving: false,
        dirty: false,
      },
      pauseForm: {
        errorMessage: "",
        successMessage: "",
        saving: false,
        dirty: false,
      },

      howTeachForm: {
        errorMessage: "",
        successMessage: "",
        saving: false,
        dirty: false,
      },

      // "howTeach" may be caveman-speak, but it's less confusible with how_i_teach
      howTeach: {
        how_i_teach: "",
        device_number: "",
      },

      showCancelDialog: false,
      showPauseDialog: false,
      showResumeDialog: false,
      promo: {
        code: "",
      },
      login: {
        username: "",
        password: "",
        password_confirm: "",
      },
      info: {
        firstname: "",
        lastname: "",
        email: "",
        mailaddress1: "",
        mailcity: "",
        mailstate: "",
        mailzip: "",
      },
      subscription: {
        is_paid_by_school: false,
        is_in_free_trial: false,
        is_paused: false,
        is_cancelled: false,
        status: "",
        type: "",
        valid_until_timestamp_utc: "",
        valid_until_pretty: "2 years from now",
        valid_until: "",
        is_paused_until: "",
        card_details: "",
        subscription_channel: "",
      },
      student: {
        send_weekly_report: false, // true, false
        retake_exm: false, // retake exam
        unlink_video: false, // Require my students to complete their fluency
        slow_video: false,
        student_username: false,
        complete_lessons_extensions: false,
        record_student_fluency: false,
        student_fluency_have_parent_permission: false,
        student_fluency_have_admin_approval: false,
        student_record_fluency_lyrics_only: false,
        welcome_message: "hello, class",
      },
      cancel: {
        reason_codes: [],
        reason: "",
      },
      pause: {
        until: "",
      },

      originalWelcomeMessage: "",

      numberOfDevices: [
        "1-3 devices",
        "4 or more devices",
      ],
      howTeachItems: [
        {
          value: "teach reading centers",
          label: "I often use centers and literacy stations when I teach reading.",
        },
        {
          value: "teacher whole group",
          label: "Most of my reading lessons are done as a class (whole group instruction).",
        },
      ],

      ALLDATA: null,
    }
  },
  computed: {
    endpoint() {
      return `/teacher/${this.teacherId}/settings`
    },
    subscriptionType: function() {
      const s = this.subscription
      if (!s) return "Unknown"
      if (s.is_paid_by_school) return "Paid for by School"
      if (s.is_in_free_trial) return "Free Trial"
      if (s.is_paused) return "Paused"
      if (s.is_cancelled || s.status === "canceled") return "Cancelled"
      return s.type
    },
    subscriptionExpirationDateLabel: function() {
      const s = this.subscription
      if (!s) return null
      if (s.is_paid_by_school) return "Subscription expiration date"
      if (s.is_in_free_trial) return "Your free trial expiration date"
      if (s.is_paused) return s.valid_until_timestamp_utc > (Date.now() / 1000) ? "Status" : "Paused Until"
      if (s.is_cancelled || s.status === "canceled") return s.valid_until_pretty?.length ? "Subscription Expires" : null
      if (s.type === 'Once') return "Your subscription expiration date"
      return "Your subscription renewal date"
    },
    subscriptionExpirationDate: function() {
      const s = this.subscription
      if (!s) return null
      if (s.is_paid_by_school || s.is_in_free_trial) return `${dateToYMD(s.valid_until)} (${s.valid_until_pretty})`
      if (s.is_paused) {
        const formatted = dateToYMD(s.valid_until)
        const resume = dateToYMD(s.is_paused_until)
        if (s.valid_until_timestamp_utc > (Date.now() / 1000)) return `Active until ${formatted}, then paused until ${resume}`
        return resume
      }
      if (s.is_cancelled || s.status === "canceled") return s.valid_until_pretty
      return `${dateToYMD(s.valid_until)} (${s.valid_until_pretty})`
    },
    subscriptionCardDetails: function() {
      const s = this.subscription
      if (!s) return null
      if (s.is_paid_by_school || s.is_in_free_trial || s.is_cancelled || s.is_paused || s.status === "canceled") return null
      return s.card_details
    },
    passwordsMatch() {
      return this.login.password === this.login.password_confirm
    },
    loginValid() {
      const u = this.login.username
      const p = this.login.password
      const pc = this.login.password_confirm
      return u.length >= 4 && u.length <= 20
        && p.length >= 6 && p.length <= 32
        && pc.length > 0
        && this.passwordsMatch
    },
    infoValid() {
      return this.info.firstname.trim().length > 0
        && this.info.lastname.trim().length > 0
        && this.info.email.trim().length > 0
        && /\S+@\S+\.\S+/.test(this.info.email)
    },
    pauseValid() {
      const v = this.pause.until
      return v.length >= 8 && v.length <= 10
    },
    subscriptionButtons: function() {
      const s = this.subscription
      if (!s || s.subscription_channel !== "stripe" || s.is_paid_by_school) return []
      if (s.is_in_free_trial || s.is_cancelled || s.status === "canceled") return ["subscribe"]
      if (s.is_paused) return ["resume", "cancel"]
      if (s.type === "Yearly") return ["update", "cancel"]
      if (s.type === "Once") return []
      return ["update", "cancel", "pause"]
    },
  },
  props: {
    apiKey: {
      type: String,
      required: true,
    },
    teacherId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    async postForm(formKey, payload, onSuccess) {
      const fm = this[formKey]
      fm.saving = true
      fm.successMessage = ""
      fm.errorMessage = ""
      try {
        const {data} = await axios.post(this.endpoint, payload)
        if (data.success) {
          fm.successMessage = data.message || ""
          if (onSuccess) onSuccess(data)
        } else {
          fm.errorMessage = data.message || ""
        }
      } catch (error) {
        if (error.response?.status === 403) {
          if (!await this.handle403()) {
            fm.errorMessage = "Your session may have expired. Please reload the page."
          }
          return
        }
        fm.errorMessage = error.toString()
      } finally {
        fm.saving = false
      }
    },

    async handle403() {
      const {data} = await axios.get("/me")
      if (data.id !== this.teacherId) {
        if (confirm(`Teacher ID (#${this.teacherId}) does not match current user (#${data.id}). Reload page?`)) {
          window.location.reload()
          return true
        }
        return false
      }
      return false
    },

    async loadSettings() {
      this.loading = true
      try {
        const {data} = await axios.post(this.endpoint, {verb: "load"})
        if (data.success) {
          this.login.username = data.username
          this.login.password = ''
          this.login.password_confirm = ''

          this.info.firstname = data.firstname
          this.info.lastname = data.lastname
          this.info.email = data.email
          this.info.mailaddress1 = data.mailaddress1
          this.info.mailcity = data.mailcity
          this.info.mailstate = data.mailstate
          this.info.mailzip = data.mailzip

          this.isActualTeacher = data._is_actual_teacher

          this.publishableKey = data.publishableKey

          this.student = data.student
          this.originalWelcomeMessage = data.student.welcome_message

          this.subscription = data.subscription

          this.howTeach = data.howTeach

          this.fluencyRecordingPossible = data.fluencyRecordingPossible

          this.ALLDATA = data
        }
      } catch (error) {
        try {
          if (error.response.data.errors.login[0]) {
            this.showError("Invalid username or password.  Please try again")
          }
        } catch {
          this.showError(error.toString())
        }
      } finally {
        this.loading = false
        this.subscriptionInformationLoading = false
      }
    },

    async updateLogin() {
      await this.postForm("loginForm", {verb: "update_login", ...this.login}, () => {
        this.login.password = ''
        this.login.password_confirm = ''
        this.loginForm.dirty = false
      })
    },

    async updateHowTeach() {
      await this.postForm("howTeachForm", {verb: "update_howteach", ...this.howTeach}, data => {
        this.howTeach.how_i_teach = data.how_i_teach
        this.howTeach.device_number = data.device_number
        this.howTeachForm.dirty = false
      })
    },

    async updateStudent() {
      if (this.student.welcome_message !== this.originalWelcomeMessage && !this.student.welcome_message.trim()) {
        return this.clearWelcomeMessage()
      }

      await this.postForm("studentForm", {verb: "update_params", ...this.student}, data => {
        this.student.send_weekly_report = data.send_weekly_report
        this.student.retake_exm = data.retake_exm
        this.student.unlink_video = data.unlink_video
        this.student.slow_video = data.slow_video
        this.student.student_username = data.student_username
        this.student.complete_lessons_extensions = data.complete_lessons_extensions
        this.student.record_student_fluency = data.record_student_fluency
        this.student.student_fluency_have_parent_permission = data.student_fluency_have_parent_permission
        this.student.student_fluency_have_admin_approval = data.student_fluency_have_admin_approval
        this.student.student_record_fluency_lyrics_only = data.student_record_fluency_lyrics_only
        this.student.welcome_message = data.welcome_message

        if (data.reload_nav) {
          this.reloadPage()
        }

        this.studentForm.dirty = false
        this.originalWelcomeMessage = this.student.welcome_message
      })
    },

    async updateInfo() {
      await this.postForm("infoForm", {verb: "update_info", ...this.info}, () => {
        this.infoForm.dirty = false
      })
    },

    async clearWelcomeMessage() {
      this.student.welcome_message = ""
      await this.postForm("studentForm", {verb: "clear_welcome_message"}, () => {
        this.student.welcome_message = ""
      })
      this.studentForm.dirty = false
      this.originalWelcomeMessage = ""
    },

    async submitPromo() {
      await this.postForm("promoForm", {verb: "update_promo", ...this.promo}, () => {
        this.promo.code = ""
        this.promoForm.dirty = false
      })
    },

    async cardUpdate() {
      await this.$refs.checkoutRef.open()
    },

    async cardDone({token}) {
      this.subscriptionInformationLoading = true
      await this.postForm("subscriptionForm", {verb: "update_card", token: token.id}, data => {
        this.subscription = data.subscription
      })
      this.subscriptionInformationLoading = false
    },

    cardCancelled() {
    },

    resumeSubscription() {
      this.showResumeDialog = true
    },
    cancelSubscription() {
      this.showCancelDialog = true
    },
    pauseSubscription() {
      this.showPauseDialog = true
    },

    async submitPause() {
      await this.postForm("pauseForm", {verb: "pause_subscription", until: this.pause.until}, () => {
        this.showPauseDialog = false
        this.reloadPage()
      })
    },

    async submitResume() {
      await this.postForm("resumeForm", {verb: "resume_subscription"}, () => {
        this.showResumeDialog = false
        this.reloadPage()
      })
    },

    async submitCancel() {
      await this.postForm("cancelForm", {
        verb: "cancel_subscription",
        reason_codes: this.cancel.reason_codes,
        reason: this.cancel.reason,
      }, () => {
        this.showCancelDialog = false
        this.reloadPage()
      })
    },

    reloadPage() {
      // FIXME: don't reload the page until the message has been seen, hide the buttons.
      window.location.reload()
    },
  },
}
</script>

<template>
  <div class="container bg-white bg-opacity-75 card p-6">
    <h1 class="text-primary">My Settings and Preferences</h1>
    <div v-if="successMessage" align="center" class="text-success" style="font-size:14px">{{ successMessage }}<br><br></div>

    <div v-if="loading">
      <h1>Loading...</h1>
    </div>
    <div v-else>
      <form novalidate>
        <div v-if="isActualTeacher" class="card mb-2">
          <div class="card-header">
            <h4 style="margin: 0;">Student Accountability Preferences</h4>
          </div>

          <div class="card-body">
            <div v-if="studentForm.errorMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-danger" role="alert">
                  {{ studentForm.errorMessage}}
                </div>
              </div>
            </div>

            <div v-if="studentForm.successMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-success" role="alert">
                  {{ studentForm.successMessage }}
                </div>
              </div>
            </div>

            <div v-if="isActualTeacher" class="row">
              <div class="col-sm-4">Weekly Report</div>
              <div class="col-sm-8">
                <div class="checkbox">
                  <label class="text-success">
                    <input type="checkbox" name="send_weekly_report" v-model="student.send_weekly_report" id="send_weekly_report" @change="studentForm.dirty = true"/>
                    I am interested in receiving a weekly report via email about the progress
                    of my students.<br>(Strongly Recommended)
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Retake Exam</div>
              <div class="col-sm-8">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" name="retake_exm" v-model="student.retake_exm" id="retake_exm" @change="studentForm.dirty = true"/>
                    Require students to retake a quiz if they score below 75%.
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Fluency Video</div>
              <div class="col-sm-8">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" name="unlink_video" v-model="student.unlink_video" id="unlink_video" @change="studentForm.dirty = true"/>
                    Require my students to complete their fluency
                    practice (choral/repeated reading 3x)
                    before progressing to the quiz.
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Slow Fluency Video</div>
              <div class="col-sm-8">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" name="slow_video" v-model="student.slow_video" value="1" id="slow_video" @change="studentForm.dirty = true"/>
                    Slow down the fluency video for my students.
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Student Username</div>
              <div class="col-sm-8">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" name="student_username" v-model="student.student_username" value="1" id="student_username" @change="studentForm.dirty = true"/>
                    I want my students to type their username rather than choosing it from a list
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Lesson Extensions</div>
              <div class="col-sm-8">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" name="complete_lessons_extensions" v-model="student.complete_lessons_extensions"
                           id="complete_lessons_extensions" @change="studentForm.dirty = true"/>
                    Requires student to complete the constructed response extension for each
                    lesson
                  </label>
                </div>
              </div>
            </div>

            <div v-if="fluencyRecordingPossible">
              <div class="row">
                <div class="col-sm-4">Record Fluency Progress</div>
                <div class="col-sm-8">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" name="record_student_fluency" v-model="student.record_student_fluency"
                             id="record_student_fluency" @change="studentForm.dirty = true"/>
                      Record student fluency performances to help assess progress.
                    </label>
                  </div>
                </div>
              </div>

              <div v-if="student.record_student_fluency" class="additional-fluency-questions">
                <div class="row hidden">
                  <div class="col-sm-4"></div>
                  <div class="col-sm-8" style="margin-bottom: 0;">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox"
                               name="student_fluency_have_parent_permission" v-model="student.student_fluency_have_parent_permission"
                               id="student_fluency_have_parent_permission" @change="studentForm.dirty = true"/>
                        All students have signed and returned a parent permission slip
                        <div style="padding: 15px 0 0 25px;">
                          <!-- teacher.file.download -->
                          <a :href="hrefs.permission_slip" target="_blank">
                            Download sample permission slip
                          </a>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-4"></div>
                  <div class="col-sm-8">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox"
                               name="student_fluency_have_admin_approval" v-model="student.student_fluency_have_admin_approval"
                               id="student_fluency_have_admin_approval" @change="studentForm.dirty = true"/>
                        I have received administrative approval from my principal to
                        record student fluency videos
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-4">
                    <label for="fluency_recording_mode">
                      When recording fluency, only show:
                    </label>
                  </div>
                  <div class="col-sm-8">
                    <div class="form-group">
                      <select
                        class="form-control form-select"
                        id="fluency_recording_mode"
                        name="fluency_recording_mode"
                        v-model="student.student_record_fluency_lyrics_only" @change="studentForm.dirty = true"
                      >
                        <option :value="false">Video Only</option>
                        <option :value="true">Text Only</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Leave a Message For My Class</div>
              <div class="col-sm-8">
                <div class="form-group" style="display: flex">
                  <input type="text" class="form-control" name="student_welcome_message"
                         id="student_welcome_message" v-model="student.welcome_message" @input="studentForm.dirty = true"/>
                </div>
              </div>
            </div>
          </div> <!-- card body -->

          <div class="card-footer text-right" v-if="studentForm.dirty">
            <button type="submit" name="btn_student_accountability" class="btn btn-success btn-md" :disabled="studentForm.saving"
                    @click.prevent="updateStudent()">
              <span v-if="studentForm.saving">Saving..</span>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </form>



      <div v-if="isActualTeacher" class="card mb-2">
        <div class="card-header">
          <h4 style="margin: 0;">Subscription Information</h4>
        </div>
        <div v-if="subscriptionInformationLoading" class="card-body">
          <h4>Updating...</h4>
        </div>
        <div class="card-body" v-else-if="subscription">
          <div v-if="subscriptionForm.errorMessage" class="row">
            <div class="col-sm-12">
              <div class="alert alert-danger" role="alert">
                {{ subscriptionForm.errorMessage}}
              </div>
            </div>
          </div>

          <div v-if="subscriptionForm.successMessage" class="row">
            <div class="col-sm-12">
              <div class="alert alert-success" role="alert">
                {{ subscriptionForm.successMessage }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">Payment Method</div>
            <div class="col-sm-8">
              <strong v-if="subscription.subscription_channel==='stripe'">Credit Card</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">Subscription Type</div>
            <div class="col-sm-8">
              <strong>{{ subscriptionType }}</strong>
            </div>
          </div>
          <div class="row" v-if="subscriptionExpirationDateLabel">
            <div class="col-sm-4">{{subscriptionExpirationDateLabel}}</div>
            <div class="col-sm-8">
              <strong>
                {{ subscriptionExpirationDate }}
              </strong>
            </div>
          </div>
          <div class="row" v-if="subscriptionCardDetails">
            <div class="col-sm-4">Current Card</div>
            <div class="col-sm-8">
              <strong>
                {{ subscriptionCardDetails }}
              </strong>
              <vue-stripe-checkout
                v-if="subscriptionButtons.includes('update')"
                ref="checkoutRef"
                image="/images/logo/logo_2_purple_200x200.png"
                name="Lyrics2Learn"
                label="Update Credit Card Details"
                :publishable-key="apiKey"
                locale="auto"
                :email="info.email"
                panelLabel="Update Credit Card"
                :allow-remember-me="false"
                @done="cardDone"
                @canceled="cardCancelled"
              >
              </vue-stripe-checkout>
              <button v-if="subscriptionButtons.includes('update')"
                      class="btn-primary btn btn-sm ml-2" @click="cardUpdate">
                Update Credit Card Details
              </button>
            </div>
          </div>
          <div v-if="subscriptionButtons.length">
            <hr/>

            <div class="row">
              <div class="col-sm-12 text-center">
                <!-- subscribe button -->
                <a v-if="subscriptionButtons.includes('subscribe')"
                   class="btn btn-primary mr-2" :href="hrefs.stripe_pay">
                  Subscribe Now
                </a>
                <button v-if="subscriptionButtons.includes('pause')" class="btn btn-primary mr-2"
                        @click.prevent="pauseSubscription()">
                  Pause My Subscription
                </button>
                <button v-if="subscriptionButtons.includes('resume')" class="btn btn-primary mr-2"
                        @click.prevent="resumeSubscription()">
                  Resume My Subscription
                </button>
                <button v-if="subscriptionButtons.includes('cancel')" class="btn btn-primary mr-2"
                        @click.prevent="cancelSubscription()">
                  Cancel My Subscription
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body" v-else>
          <div class="row">
            <div class="col-sm-12 text-center">
              <a class="btn btn-primary" :href="hrefs.stripe_pay">Subscribe Now</a>
            </div>
          </div>
        </div>
      </div>

      <form novalidate>
        <div class="card mb-2">
          <div class="card-header">
            <h4 style="margin: 0;">Login Information</h4>
            <div>
              <span style="color:#CC0000">*</span>
              <span style="font-size:11px">indicates required fields.</span>
            </div>
          </div>
          <div class="card-body">
            <div v-if="loginForm.errorMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-danger" role="alert">
                  {{ loginForm.errorMessage }}
                </div>
              </div>
            </div>

            <div v-if="loginForm.successMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-success" role="alert">
                  {{ loginForm.successMessage }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Username<span style="color:#CC0000">*</span></div>
              <div class="col-sm-8">
                <div class="form-group">
                  <input required type="text" class="form-control" name="username" id="username"
                         autocomplete="off" autocapitalize="off" spellcheck="false"
                         minlength="4" maxlength="20"
                         v-model="login.username" @input="loginForm.dirty = true"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">New Password<span style="color:#CC0000">*</span></div>
              <div class="col-sm-8">
                <div class="form-group">
                  <input required type="password" class="form-control" name="password"
                         autocomplete="off" autocapitalize="off" spellcheck="false"
                         minlength="6" maxlength="32"
                         id="password" v-model="login.password" @input="loginForm.dirty = true"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">Confirm Password<span style="color:#CC0000">*</span></div>
              <div class="col-sm-8">
                <div class="form-group">
                  <input required type="password" class="form-control" name="password_confirm"
                         autocomplete="off" autocapitalize="off" spellcheck="false"
                         id="password-confirm" v-model="login.password_confirm" @input="loginForm.dirty = true"/>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer text-right" v-if="loginForm.dirty">
            <button type="submit" value="btn_login_info" name="btn_login_info" @click.prevent="updateLogin()" class="btn btn-success btn-md" :disabled="loginForm.saving || !loginValid">
              <span v-if="loginForm.saving">Saving...</span>
              <span v-else>Update Login Information</span>
            </button>
          </div>
        </div>
      </form>

      <form novalidate>
        <div class="card mb-2">
          <div class="card-header">
            <h4 style="margin: 0;">My Information</h4>
            <div>
              <span style="color:#CC0000">*</span>
              <span style="font-size:11px">indicates required fields.</span>
            </div>
          </div>

          <div class="card-body">
            <div v-if="infoForm.errorMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-danger" role="alert">
                  {{ infoForm.errorMessage }}
                </div>
              </div>
            </div>

            <div v-if="infoForm.successMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-success" role="alert">
                  {{ infoForm.successMessage }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">First name <span style="color:#CC0000">*</span></div>
              <div class="col-sm-8">
                <div class="form-group">
                  <input type="text" class="form-control" name="firstname" id="firstname"
                         autocomplete="off" spellcheck="false" required
                         v-model="info.firstname" @input="infoForm.dirty = true"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Last name <span style="color:#CC0000">*</span></div>
              <div class="col-sm-8">
                <div class="form-group">
                  <input type="text" class="form-control" name="lastname" id="lastname"
                         autocomplete="off" spellcheck="false" required
                         v-model="info.lastname" @input="infoForm.dirty = true"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Email <span style="color:#CC0000">*</span></div>
              <div class="col-sm-8">
                <div class="form-group">
                  <input type="email" class="form-control" name="email" id="email"
                         autocomplete="off" autocapitalize="off" spellcheck="false" required
                         v-model="info.email" @input="infoForm.dirty = true"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Address 1</div>
              <div class="col-sm-8">
                <div class="form-group">
								<textarea id="mailaddress1" class="form-control" name="mailaddress1" v-model="info.mailaddress1" @input="infoForm.dirty = true">
								</textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">City</div>
              <div class="col-sm-8">
                <div class="form-group">
                  <input type="text" class="form-control" name="mailcity" id="mailcity"
                         v-model="info.mailcity" @input="infoForm.dirty = true" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">State</div>
              <div class="col-sm-8">
                <div class="form-group">
                  <input type="text" class="form-control" name="mailstate" id="mailstate"
                         v-model="info.mailstate" @input="infoForm.dirty = true" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">Zip</div>
              <div class="col-sm-8">
                <div class="form-group">
                  <input type="text" class="form-control" name="mailzip" id="mailzip"
                         v-model="info.mailzip" @input="infoForm.dirty = true" />
                </div>
              </div>
            </div>

          </div>

          <div class="card-footer text-right" v-if="infoForm.dirty">
            <button type="submit" name="btn_user_info" class="btn btn-success btn-md" :disabled="!infoValid" @click.prevent="updateInfo()">
              <span v-if="infoForm.saving">Saving...</span>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </form>

      <form v-if="isActualTeacher" novalidate>
        <div class="card mb-2">
          <div class="card-header">
            <h4 style="margin: 0;">How I Teach</h4>
          </div>

          <div class="card-body">
            <div v-if="howTeachForm.errorMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-danger" role="alert">
                  {{ howTeachForm.errorMessage}}
                </div>
              </div>
            </div>

            <div v-if="howTeachForm.successMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-success" role="alert">
                  {{ howTeachForm.successMessage }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">
                <label for="how_i_teach">
                  I teach reading using:
                </label>
              </div>
              <div class="col-sm-8">
                <div class="form-group">
                  <select
                    class="form-control form-select"
                    id="how_i_teach"
                    name="how_i_teach"
                    v-model="howTeach.how_i_teach" @change="howTeachForm.dirty = true"
                  >
                    <option value="">Select</option>
                    <option
                      v-for="how in howTeachItems"
                      :value="how.value"
                      :key="how.value"
                    >{{ how.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">
                <label for="device_number">
                  Number of devices in my classroom
                </label>
              </div>
              <div class="col-sm-8">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="device_number"
                    name="device_number"
                    v-model="howTeach.device_number" @change="howTeachForm.dirty = true"
                  >
                    <option value="">Select</option>
                    <option
                      v-for="(quantity, index) in numberOfDevices"
                      :value="quantity"
                      :key="index"
                    >{{ quantity }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="card-footer text-right" v-if="howTeachForm.dirty">
                <button type="submit" name="btn_how_i_teach" class="btn btn-success btn-md" :disabled="howTeachForm.saving" @click.prevent="updateHowTeach()">
                  <span v-if="howTeachForm.saving">Saving...</span>
                  <span v-else>Save</span>
                </button>
              </div>

            </div>


          </div>
        </div>
      </form>

      <form v-if="false && isActualTeacher" name="frm3" novalidate>
        <!-- LL2L-401 removed this.  Probably for good, but leaving it just hidden for now -->
        <div class="card mb-2">
          <div class="card-header">
            <h4 style="margin: 0;">Enter Free Month Subscription Promo Code</h4>
          </div>

          <div class="card-body">
            <div v-if="promoForm.errorMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-danger" role="alert">
                  {{ promoForm.errorMessage }}
                </div>
              </div>
            </div>

            <div v-if="promoForm.successMessage" class="row">
              <div class="col-sm-12">
                <div class="alert alert-success" role="alert">
                  {{ promoForm.successMessage }}
                </div>
              </div>
            </div>

            <div class="form-group">
              <input type="text" class="form-control" name="free_month_subscription_promo"
                     autocomplete="off" autocapitalize="off" spellcheck="false"
                     v-model="promo.code" @input="promoForm.dirty = true"/>
            </div>
          </div>

          <div class="card-footer text-right" v-if="promoForm.dirty" >
            <button name="btn_free_month_subscr_promo" type="submit" class="btn btn-success btn-md"
                    :disabled="promoForm.saving"
                    @click.prevent="submitPromo">
              <span v-if="promoForm.saving">Validating...</span>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </form>
    </div>

    <b-modal v-model="showCancelDialog" title="Welcome" ref="modal" hide-header>
      <form>
        <div v-if="cancelForm.errorMessage" class="row">
          <div class="col-sm-12">
            <div class="alert alert-danger" role="alert">
              {{ cancelForm.errorMessage}}
            </div>
          </div>
        </div>

        <div v-if="cancelForm.successMessage" class="row">
          <div class="col-sm-12">
            <div class="alert alert-success" role="alert">
              {{ cancelForm.successMessage }}
            </div>
          </div>
        </div>

        <h3>I am canceling because (choose any that apply):</h3>
        <div class="row">
          <div class="col-sm-8">
            <div class="checkbox">
              <label>
                <input value="1" type="checkbox" v-model="cancel.reason_codes" @change="cancelForm.dirty = true" />

                1. I chose not to use L2L with my student/s.
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8">
            <div class="checkbox">
              <label>
                <input value="2" type="checkbox" v-model="cancel.reason_codes" @change="cancelForm.dirty = true" />
                2. L2L did not work on my tablet or computer
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8">
            <div class="checkbox">
              <label>
                <input value="3" type="checkbox" v-model="cancel.reason_codes" @change="cancelForm.dirty = true" />
                3. I did not get school funding for L2L
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8">Other
            <input v-model="cancel.reason" type="text" class="form-control" @input="cancelForm.dirty = true">
          </div>
        </div>
      </form>

      <div slot="modal-footer">
        <button class="btn btn-danger" @click.prevent="submitCancel()" :disabled="cancelForm.saving">
          <span v-if="cancelForm.saving">Cancelling subscription...</span>
          <span v-else>Cancel My Subscription</span>
        </button>
        <button class="btn btn-default" @click.prevent="showCancelDialog = false">
          Cancel
        </button>
      </div>
    </b-modal>

    <b-modal v-model="showPauseDialog" title="Pause Subscription" ref="modal" hide-header>
      <form>
        <h3>Pause Subscription</h3>
        <div v-if="pauseForm.errorMessage" class="row">
          <div class="col-sm-12">
            <div class="alert alert-danger" role="alert">
              {{ pauseForm.errorMessage}}
            </div>
          </div>
        </div>

        <div v-if="pauseForm.successMessage" class="row">
          <div class="col-sm-12">
            <div class="alert alert-success" role="alert">
              {{ pauseForm.successMessage }}
            </div>
          </div>
        </div>

        <p>
          <strong>NOTE: </strong>
          This feature will pause billing on your account until the date you specify.
          Our billing system works on a 30 day cycle.  Please do not use this feature to pause subscriptions
          over the weekend or during times when you will be inactive for less than a 30 day billing cycle.
          Otherwise, it could result in your account being double billed.
        </p>
        <div class="row">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-6">
                Pause subscription until this date:
              </div>
              <div class="col-sm-4">
                <input v-model="pause.until"
                       autocomplete="off" autocapitalize="off" spellcheck="false"
                       minlength="8" maxlength="10"
                       class="form-control" size="10" type="text" @input="pauseForm.dirty = true">
                <small>&nbsp;&nbsp;(yyyy-mm-dd)</small>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div slot="modal-footer">
        <button class="btn btn-default" @click.prevent="showPauseDialog = false">
          Cancel
        </button>
        <button class="btn btn-danger" @click.prevent="submitPause()" :disabled="pauseForm.saving || !pauseValid">
          <span v-if="pauseForm.saving">Pausing subscription...</span>
          <span v-else>Pause My Subscription</span>
        </button>
      </div>
    </b-modal>


    <b-modal v-model="showResumeDialog" title="Welcome" ref="modal" hide-header>
      <form>
        <div v-if="resumeForm.errorMessage" class="row">
          <div class="col-sm-12">
            <div class="alert alert-danger" role="alert">
              {{ resumeForm.errorMessage}}
            </div>
          </div>
        </div>

        <div v-if="resumeForm.successMessage" class="row">
          <div class="col-sm-12">
            <div class="alert alert-success" role="alert">
              {{ resumeForm.successMessage }}
            </div>
          </div>
        </div>

        <h3>Resume Your Subscription</h3>
        <p>By clicking on Resume below, you will re-instate your subscription.</p>
      </form>

      <div slot="modal-footer">
        <button class="btn btn-default" @click.prevent="showResumeDialog = false">
          Cancel
        </button>
        <button class="btn btn-primary" @click.prevent="submitResume()" :disabled="resumeForm.saving">
          <span v-if="resumeForm.saving">Resuming subscription...</span>
          <span v-else>Resume My Subscription</span>
        </button>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
    label {
        // Temporary until everything is consistently using labels
        font-weight: initial;
    }
</style>
